import {
    SEND_EMAIL_WITH_RECOMMENDATIONS,
    SEND_EMAIL_WITH_RECOMMENDATIONS_SUCCESS,
    SEND_EMAIL_WITH_RECOMMENDATIONS_FAILURE,
} from '../../constants';

const sendEmailRecommendationsState = {
    isLoading: false,
    isEmailSentSuccess: false,
    isEmailSentFailed: false,
};

export default function sendEmailRecommendationsReducer(
    state = sendEmailRecommendationsState,
    action,
) {
    switch (action.type) {
        case SEND_EMAIL_WITH_RECOMMENDATIONS: {
            return {
                ...state,
                isLoading: true,
                isEmailSentSuccess: false,
                isEmailSentFailed: false,
            };
        }
        case SEND_EMAIL_WITH_RECOMMENDATIONS_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                isEmailSentSuccess: true,
            };
        }

        case SEND_EMAIL_WITH_RECOMMENDATIONS_FAILURE: {
            return {
                ...state,
                isLoading: false,
                isEmailSentFailed: true,
            };
        }

        default:
            return state;
    }
}
